/**
 * Single source of truth for the brand hex colors that are applied via
 * inline `style={{}}`.
 *
 * Two forms exist:
 *
 *   - `BRAND_NAVY` / `BRAND_SIDEBAR` are **fixed light-mode hexes**.
 *     Use these only for elements that should keep their identity in
 *     dark mode (the brand FAB stays navy in dark too).
 *
 *   - `BRAND_NAVY_VAR` / `BRAND_SIDEBAR_VAR` resolve to the
 *     `--brand-navy` / `--brand-sidebar` CSS variables, which `.dark`
 *     in `src/index.css` overrides. Use these for foreground / surface
 *     colors that need to flip with theme (e.g. the topbar background
 *     and the icons painted on it).
 */
export const BRAND_NAVY = '#1a2e5a';
export const BRAND_SIDEBAR = '#e8eaed';

export const BRAND_NAVY_VAR = 'hsl(var(--brand-navy))';
export const BRAND_SIDEBAR_VAR = 'hsl(var(--brand-sidebar))';
